var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconAdd01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 26 26"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 24.2,
  height: 24.2,
  x: 0.9,
  y: 0.9,
  stroke: "#fff",
  strokeWidth: 1.8,
  rx: 7.1
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M6.8 12.2h12.5v1.6H6.8z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13.8 6.8v12.5h-1.6V6.8z"
})));
export default SvgIconAdd01;